module.exports = __webpack_public_path__ + "static/media/bac-parking-selected.7dce0322.svg";